/**
 * Parses a `"YYYY-MM"` statement period into a local `Date` at the first of
 * that month. `new Date('2026-02')` parses as UTC midnight, which formats as
 * the previous month in any negative-offset timezone.
 */
export const parseStatementPeriod = (period: string) => {
  const [year, month] = period.split('-')

  return new Date(Number(year), Number(month) - 1, 1)
}
